import React, {useState} from 'react';
import {Button} from "@mui/material";
import usePrizeStyles from "../../styles/ncp2026/prize";
import clsx from "clsx";
import Form from './Form';

// Import imagini magazine
// import logo1 from '../../assets/images/ncp/2026/logo1.png';
// import logo1_selected from '../../assets/images/ncp/2026/logo1_selected.png';
// import logo2 from '../../assets/images/ncp/2026/logo2.png';
// import logo2_selected from '../../assets/images/ncp/2026/logo2_selected.png';
import logo4 from '../../assets/images/ncp/2026/logo4.png';
import logo4_selected from '../../assets/images/ncp/2026/logo4_selected.png';
// import logo5 from '../../assets/images/ncp/2026/logo5.png';
// import logo5_selected from '../../assets/images/ncp/2026/logo5_selected.png';
import profi from '../../assets/images/ncp/2026/profi.png';
import profi_selected from '../../assets/images/ncp/2026/profi_selected.png';
// import auchan from '../../assets/images/ncp/2026/auchan.png';
// import auchan_selected from '../../assets/images/ncp/2026/auchan_selected.png';

// Import premii
// import carrefour_p1 from '../../assets/images/ncp/2026/abonament-spotify.png';
// import carrefour_p2 from '../../assets/images/ncp/2026/carrefour_p2.png';
// import lidl_p1 from '../../assets/images/ncp/2026/LIDL_p1.png';
// import lidl_p2 from '../../assets/images/ncp/2026/LIDL_p2.png';
// import kauf_p1 from '../../assets/images/ncp/2026/kauf_p1.png';
// import kauf_p2 from '../../assets/images/ncp/2026/kauf_p2.png';
import profi_p1 from '../../assets/images/ncp/2026/profi_p1.png';
import profi_p2 from '../../assets/images/ncp/2026/profi_p2.png';
// import auchan_p1 from '../../assets/images/ncp/2026/auchan_p1.png';
// import auchan_p2 from '../../assets/images/ncp/2026/auchan_p2.png';

// Import cifre
import digit_1 from '../../assets/images/digit_1.png';
import digit_2 from '../../assets/images/digit_2.png';
import digit_3 from '../../assets/images/digit_3.png';

const partners = {
    // carrefour: 'carrefour',
    // lidl: 'lidl',
    mega: 'mega',
    // kaufland: 'kaufland',
    profi: 'profi',
    // auchan: 'auchan',
};

const partnerLogos = {
    // [partners.carrefour]: {
    //     normal: logo1,
    //     selected: logo1_selected,
    // },
    // [partners.lidl]: {
    //     normal: logo2,
    //     selected: logo2_selected,
    // },
    [partners.mega]: {
        normal: logo4,
        selected: logo4_selected,
    },
    // [partners.kaufland]: {
    //     normal: logo5,
    //     selected: logo5_selected,
    // },
    [partners.profi]: {
        normal: profi,
        selected: profi_selected,
    },
    // [partners.auchan]: {
    //     normal: auchan,
    //     selected: auchan_selected,
    // },
};

const partnerTitles = {
    // [partners.carrefour]: 'Kozel și Carrefour te premiază!',
    // [partners.lidl]: 'Kozel și Lidl te premiază!',
    [partners.mega]: 'Kozel și Mega Image te premiază!',
    // [partners.kaufland]: 'Kozel și Kaufland te premiază!',
    [partners.profi]: 'Kozel și Profi te premiază!',
    // [partners.auchan]: 'Kozel și Auchan te premiază!',
};

const partnerPrizes: Record<string, { p1: string; p2: string }> = {
    // [partners.carrefour]: { p1: carrefour_p1, p2: carrefour_p2 },
    // [partners.lidl]: { p1: lidl_p1, p2: lidl_p2 },
    [partners.mega]: { p1: profi_p1, p2: profi_p2 }, 
    // [partners.kaufland]: { p1: kauf_p1, p2: kauf_p2 },
    [partners.profi]: { p1: profi_p1, p2: profi_p2 },
    // [partners.auchan]: { p1: auchan_p1, p2: auchan_p2 },
};

const Prize: React.FC = () => {
    const prizeStyles = usePrizeStyles();
    const [selectedPartner, setSelectedPartner] = useState(partners.mega);

    const handlePartnerChange = (partner: string) => {
        setSelectedPartner(partner);
    };

    return (
        <div className={prizeStyles.prizeContainer}>
            <div className={prizeStyles.contentWrapper}>
                {/* Selectare magazine */}
                <div className={prizeStyles.partnerSelectionBox}>
                    {Object.values(partners).map((partner) => (
                        <div
                            key={partner}
                            className={clsx(
                                prizeStyles.partnerSelection,
                                selectedPartner === partner && 'active'
                            )}
                        >
                            <Button onClick={() => handlePartnerChange(partner)}>
                                <img
                                    src={
                                        selectedPartner === partner
                                            ? partnerLogos[partner].selected
                                            : partnerLogos[partner].normal
                                    }
                                    alt={partner}
                                />
                            </Button>
                        </div>
                    ))}
                </div>

                {/* Premii banner */}
                <div className={prizeStyles.prizeBannerBox}>
                    <img src={partnerPrizes[selectedPartner].p1} alt="Premiul 1" className={prizeStyles.prizeImage} />
                    <img src={partnerPrizes[selectedPartner].p2} alt="Premiul 2" className={prizeStyles.prizeImage} />
                </div>

                {/* Titlu și perioadă */}
                <div className={prizeStyles.titleBox}>
                    <div className={prizeStyles.title}>
                        {partnerTitles[selectedPartner]}
                    </div>
                    <div className={prizeStyles.subtitle}>
                        05 martie - 31 mai 2026
                    </div>
                </div>

                {/* Pași */}
                <div className={prizeStyles.stepsContainer}>
                    {/* Pas 1 - Cifra stânga */}
                    <div className={prizeStyles.prizeStep}>
                        <img src={digit_1} alt="1" className={prizeStyles.digitImg} />
                        <div className={prizeStyles.prizeStepText}>
                            Cumpără Kozel de 25 RON pe același bon fiscal.
                        </div>
                    </div>

                    {/* Pas 2 - Cifra dreapta */}
                    <div className={prizeStyles.prizeStep}>
                        <img src={digit_2} alt="2" className={prizeStyles.digitImg2} />
                        <div className={prizeStyles.prizeStepText}>
                            Înscrie numărul de bon, completează formularul și intri în tragerea la sorți pentru unul din premiile campaniei, poi câștiga un premiu prin tragere în fiecare magazin, în plus, apoi automat în tragerea la sorți pentru marele premiu.
                        </div>
                    </div>

                    {/* Pas 3 - Cifra stânga */}
                    <div className={prizeStyles.prizeStep}>
                        <img src={digit_3} alt="3" className={prizeStyles.digitImg} />
                        <div className={prizeStyles.prizeStepText}>
                            Păstrează bonul fiscal pentru validarea premiului, în cazul în care vei fi declarat potențial câștigător.
                        </div>
                    </div>
                </div>
                {/* Formular */}
                <Form partner={selectedPartner} />
            </div>
        </div>
    );
};

export default Prize;